import React from "react";
import { Link } from "react-router-dom";
import { getLatestPosts } from "../data/blog-posts";

import ImgTech from "../assets/images/banner-images/banner-enterprise.jpg";
import ImgAI from "../assets/images/blog-ai-banner.svg";
import ImgIndustry from "../assets/images/banner-images/banner-tdx.jpg";
import ImgAPI from "../assets/images/banner-images/banner-development-api.jpg";

const categoryImages = {
  "Travel Technology": ImgTech,
  "AI in Travel": ImgAI,
  "Industry Insights": ImgIndustry,
  "API Integration": ImgAPI,
};

const categoryColors = {
  "Travel Technology": "#0d6efd",
  "AI in Travel": "#e85d04",
  "Industry Insights": "#6f42c1",
  "API Integration": "#198754",
};

const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const HomeBlog = () => {
  const posts = getLatestPosts(3);

  return (
    <div className="home-blog mt-5">
      <div className="container text-center">
        <h2 className="text-center mb-2">Latest from Our Blog</h2>
        <p className="text-secondary mb-5">Travel technology insights, AI in travel, and platform engineering perspectives.</p>

        <div className="row">
          {posts.map((post) => (
            <div key={post.id} className="col-lg-4 mb-4">
              <div className="home-blog-box h-100 d-flex flex-column" style={{ borderRadius: 10, overflow: "hidden", border: "1px solid #eee", background: "#fff" }}>
                <div style={{ position: "relative", height: 180, overflow: "hidden" }}>
                  <img
                    src={categoryImages[post.category] || ImgTech}
                    alt={post.title}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <span
                    style={{
                      position: "absolute", top: 10, left: 10,
                      background: categoryColors[post.category] || "#0d6efd",
                      color: "#fff", fontSize: 11, fontWeight: 600,
                      padding: "2px 10px", borderRadius: 20
                    }}
                  >
                    {post.category}
                  </span>
                </div>
                <div className="p-4 d-flex flex-column flex-grow-1 text-start">
                  <div className="d-flex align-items-center mb-2" style={{ gap: 10, fontSize: 12, color: "#999" }}>
                    <span>{formatDate(post.date)}</span>
                    <span>·</span>
                    <span>{post.readTime} read</span>
                  </div>
                  <h5 className="mb-2" style={{ fontSize: 15, fontWeight: 700, lineHeight: 1.4 }}>{post.title}</h5>
                  <p className="small text-secondary mb-3 flex-grow-1" style={{ lineHeight: 1.6 }}>
                    {post.excerpt.length > 120 ? post.excerpt.slice(0, 120) + "…" : post.excerpt}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="btn btn-sm btn-primary mt-auto"
                    style={{ borderRadius: 20, alignSelf: "flex-start" }}
                  >
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-3">
          <Link to="/blog" className="btn btn-outline-primary px-4" style={{ borderRadius: 30 }}>
            View All Articles
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeBlog;
